<template>
  <div id="app">
    <router-view/>
    <apoc-record-bar v-if="showUserFooter" />
  </div>
</template>

<script>
import { ensureSiteConfig } from '@/store/site-config'
import ApocRecordBar from '@/components/ApocRecordBar.vue'

export default {
  name: 'AppRoot',
  components: { ApocRecordBar },
  created () {
    ensureSiteConfig()
  },
  computed: {
    showUserFooter () {
      return !this.$route.matched.some(r => r.meta && r.meta.admin)
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
